import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=73139f3e&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"
import style0 from "./eventDetail.css?vue&type=style&index=0&id=73139f3e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73139f3e",
  null
  
)

export default component.exports